import APIDocsAddTagBlock from './blocks/APIDocsAddTagBlock';
import APIDocsAIBlock from './blocks/APIDocsAIBlock';
import APIDocsAIEnqueueFeedbackBlock from './blocks/APIDocsAIEnqueueFeedbackBlock';
import APIDocsAuthenticationBlock from './blocks/APIDocsAuthenticationBlock';
import APIDocsBoardObjectBlock from './blocks/APIDocsBoardObjectBlock';
import APIDocsBoardsBlock from './blocks/APIDocsBoardsBlock';
import APIDocsCategoriesBlock from './blocks/APIDocsCategoriesBlock';
import APIDocsCategoryObjectBlock from './blocks/APIDocsCategoryObjectBlock';
import APIDocsChangePostCategoryBlock from './blocks/APIDocsChangePostCategoryBlock';
import APIDocsChangePostStatusBlock from './blocks/APIDocsChangePostStatusBlock';
import APIDocsCommentObjectBlock from './blocks/APIDocsCommentObjectBlock';
import APIDocsCommentsBlock from './blocks/APIDocsCommentsBlock';
import APIDocsCompaniesBlock from './blocks/APIDocsCompaniesBlock';
import APIDocsCreateCategoryBlock from './blocks/APIDocsCreateCategoryBlock';
import APIDocsCreateCommentBlock from './blocks/APIDocsCreateCommentBlock';
import APIDocsCreateCompanyBlock from './blocks/APIDocsCreateCompanyBlock';
import APIDocsCreateEntryBlock from './blocks/APIDocsCreateEntryBlock';
import APIDocsCreateOrUpdateUserBlock from './blocks/APIDocsCreateOrUpdateUserBlock';
import APIDocsCreatePostBlock from './blocks/APIDocsCreatePostBlock';
import APIDocsCreateTagBlock from './blocks/APIDocsCreateTagBlock';
import APIDocsCreateVoteBlock from './blocks/APIDocsCreateVoteBlock';
import APIDocsDeleteCategoryBlock from './blocks/APIDocsDeleteCategoryBlock';
import APIDocsDeleteCommentBlock from './blocks/APIDocsDeleteCommentBlock';
import APIDocsDeleteCompanyBlock from './blocks/APIDocsDeleteCompanyBlock';
import APIDocsDeletePostBlock from './blocks/APIDocsDeletePostBlock';
import APIDocsDeleteUserBlock from './blocks/APIDocsDeleteUserBlock';
import APIDocsDeleteUserFromCompanyBlock from './blocks/APIDocsDeleteUserFromCompanyBlock';
import APIDocsDeleteVoteBlock from './blocks/APIDocsDeleteVoteBlock';
import APIDocsEntriesBlock from './blocks/APIDocsEntriesBlock';
import APIDocsEntryObjectBlock from './blocks/APIDocsEntryObjectBlock';
import APIDocsEventObjectBlock from './blocks/APIDocsEventObjectBlock';
import APIDocsEventTypesBlock from './blocks/APIDocsEventTypesBlock';
import APIDocsIntroductionBlock from './blocks/APIDocsIntroductionBlock';
import APIDocsJiraLinkIssueBlock from './blocks/APIDocsJiraLinkIssueBlock';
import APIDocsJiraUnlinkIssueBlock from './blocks/APIDocsJiraUnlinkIssueBlock';
import APIDocsListBoardsBlock from './blocks/APIDocsListBoardsBlock';
import APIDocsListCategoriesBlock from './blocks/APIDocsListCategoriesBlock';
import APIDocsListCommentsBlock from './blocks/APIDocsListCommentsBlock';
import APIDocsListCompaniesBlock from './blocks/APIDocsListCompaniesBlock';
import APIDocsListEntriesBlock from './blocks/APIDocsListEntriesBlock';
import APIDocsListOpportunitiesBlock from './blocks/APIDocsListOpportunitiesBlock';
import APIDocsListPostsBlock from './blocks/APIDocsListPostsBlock';
import APIDocsListStatusChangesBlock from './blocks/APIDocsListStatusChangesBlock';
import APIDocsListTagsBlock from './blocks/APIDocsListTagsBlock';
import APIDocsListUsersBlock from './blocks/APIDocsListUsersBlock';
import APIDocsListVotesBlock from './blocks/APIDocsListVotesBlock';
import APIDocsOpportunitiesBlock from './blocks/APIDocsOpportunitiesBlock';
import APIDocsOpportunityObjectBlock from './blocks/APIDocsOpportunityObjectBlock';
import APIDocsPaginationBlock from './blocks/APIDocsPaginationBlock';
import APIDocsPostObjectBlock from './blocks/APIDocsPostObjectBlock';
import APIDocsPostsBlock from './blocks/APIDocsPostsBlock';
import APIDocsRemoveTagBlock from './blocks/APIDocsRemoveTagBlock';
import APIDocsRetrieveBoardBlock from './blocks/APIDocsRetrieveBoardBlock';
import APIDocsRetrieveCategoryBlock from './blocks/APIDocsRetrieveCategoryBlock';
import APIDocsRetrieveCommentBlock from './blocks/APIDocsRetrieveCommentBlock';
import APIDocsRetrievePostBlock from './blocks/APIDocsRetrievePostBlock';
import APIDocsRetrieveTagBlock from './blocks/APIDocsRetrieveTagBlock';
import APIDocsRetrieveUserBlock from './blocks/APIDocsRetrieveUserBlock';
import APIDocsRetrieveVoteBlock from './blocks/APIDocsRetrieveVoteBlock';
import APIDocsRoadmapObjectBlock from './blocks/APIDocsRoadmapObjectBlock';
import APIDocsRoadmapsBlock from './blocks/APIDocsRoadmapsBlock';
import APIDocsStatusChangeObjectBlock from './blocks/APIDocsStatusChangeObjectBlock';
import APIDocsStatusChangesBlock from './blocks/APIDocsStatusChangesBlock';
import APIDocsTagObjectBlock from './blocks/APIDocsTagObjectBlock';
import APIDocsTagsBlock from './blocks/APIDocsTagsBlock';
import APIDocsUpdateCompanyBlock from './blocks/APIDocsUpdateCompanyBlock';
import APIDocsUpdatePostBlock from './blocks/APIDocsUpdatePostBlock';
import APIDocsUserObjectBlock from './blocks/APIDocsUserObjectBlock';
import APIDocsUsersBlock from './blocks/APIDocsUsersBlock';
import APIDocsVoteObjectBlock from './blocks/APIDocsVoteObjectBlock';
import APIDocsVotesBlock from './blocks/APIDocsVotesBlock';
import APIDocsWebhooksBlock from './blocks/APIDocsWebhooksBlock';
import APIDocsWebhookSignatureBlock from './blocks/APIDocsWebhookSignatureBlock';

type APIDocsSection = {
  block: React.ReactNode;
  id: string;
  main: boolean;
  name: string;
};

const APIDocsSections: APIDocsSection[] = [
  {
    block: APIDocsIntroductionBlock,
    id: 'intro',
    main: true,
    name: 'Introduction',
  },
  {
    block: APIDocsAuthenticationBlock,
    id: 'authentication',
    main: false,
    name: 'Authentication',
  },
  {
    block: APIDocsPaginationBlock,
    id: 'pagination',
    main: false,
    name: 'Pagination',
  },
  {
    block: APIDocsBoardsBlock,
    id: 'boards',
    main: true,
    name: 'Boards',
  },
  {
    block: APIDocsBoardObjectBlock,
    id: 'board_object',
    main: false,
    name: 'Board object',
  },
  {
    block: APIDocsRetrieveBoardBlock,
    id: 'retrieve_board',
    main: false,
    name: 'Retrieve board',
  },
  {
    block: APIDocsListBoardsBlock,
    id: 'list_all_boards',
    main: false,
    name: 'List all boards',
  },
  {
    block: APIDocsCategoriesBlock,
    id: 'categories',
    main: true,
    name: 'Categories',
  },
  {
    block: APIDocsCategoryObjectBlock,
    id: 'category_object',
    main: false,
    name: 'Category object',
  },
  {
    block: APIDocsRetrieveCategoryBlock,
    id: 'retrieve_category',
    main: false,
    name: 'Retrieve category',
  },
  {
    block: APIDocsListCategoriesBlock,
    id: 'list_categories',
    main: false,
    name: 'List categories',
  },
  {
    block: APIDocsCreateCategoryBlock,
    id: 'create_category',
    main: false,
    name: 'Create category',
  },
  {
    block: APIDocsDeleteCategoryBlock,
    id: 'delete_category',
    main: false,
    name: 'Delete category',
  },
  {
    block: APIDocsEntriesBlock,
    id: 'entries',
    main: true,
    name: 'Changelog Entries',
  },
  {
    block: APIDocsEntryObjectBlock,
    id: 'entry_object',
    main: false,
    name: 'Entry object',
  },
  {
    block: APIDocsCreateEntryBlock,
    id: 'create_entry',
    main: false,
    name: 'Create entry',
  },
  {
    block: APIDocsListEntriesBlock,
    id: 'list_entries',
    main: false,
    name: 'List entries',
  },
  {
    block: APIDocsCommentsBlock,
    id: 'comments',
    main: true,
    name: 'Comments',
  },
  {
    block: APIDocsCommentObjectBlock,
    id: 'comment_object',
    main: false,
    name: 'Comment object',
  },
  {
    block: APIDocsRetrieveCommentBlock,
    id: 'retrieve_comment',
    main: false,
    name: 'Retrieve comment',
  },
  {
    block: APIDocsListCommentsBlock,
    id: 'list_comments',
    main: false,
    name: 'List comments',
  },
  {
    block: APIDocsCreateCommentBlock,
    id: 'create_comment',
    main: false,
    name: 'Create comment',
  },
  {
    block: APIDocsDeleteCommentBlock,
    id: 'delete_comment',
    main: false,
    name: 'Delete comment',
  },
  {
    block: APIDocsCompaniesBlock,
    id: 'companies',
    main: true,
    name: 'Companies',
  },
  {
    block: APIDocsListCompaniesBlock,
    id: 'list_companies',
    main: false,
    name: 'List companies',
  },
  {
    block: APIDocsCreateCompanyBlock,
    id: 'create_company',
    main: false,
    name: 'Create company',
  },
  {
    block: APIDocsUpdateCompanyBlock,
    id: 'update_company',
    main: false,
    name: 'Update company',
  },
  {
    block: APIDocsDeleteCompanyBlock,
    id: 'delete_company',
    main: false,
    name: 'Delete company',
  },
  {
    block: APIDocsOpportunitiesBlock,
    id: 'opportunities',
    main: true,
    name: 'Opportunities',
  },
  {
    block: APIDocsOpportunityObjectBlock,
    id: 'opportunity_object',
    main: false,
    name: 'Opportunity object',
  },
  {
    block: APIDocsListOpportunitiesBlock,
    id: 'list_opportunities',
    main: false,
    name: 'List opportunities',
  },
  {
    block: APIDocsPostsBlock,
    id: 'posts',
    main: true,
    name: 'Posts',
  },
  {
    block: APIDocsPostObjectBlock,
    id: 'post_object',
    main: false,
    name: 'Post object',
  },
  {
    block: APIDocsRetrievePostBlock,
    id: 'retrieve_post',
    main: false,
    name: 'Retrieve post',
  },
  {
    block: APIDocsListPostsBlock,
    id: 'list_posts',
    main: false,
    name: 'List posts',
  },
  {
    block: APIDocsCreatePostBlock,
    id: 'create_post',
    main: false,
    name: 'Create post',
  },
  {
    block: APIDocsChangePostCategoryBlock,
    id: 'change_post_category',
    main: false,
    name: 'Change post category',
  },
  {
    block: APIDocsChangePostStatusBlock,
    id: 'change_post_status',
    main: false,
    name: 'Change post status',
  },
  {
    block: APIDocsAddTagBlock,
    id: 'add_tag',
    main: false,
    name: 'Add post tag',
  },
  {
    block: APIDocsRemoveTagBlock,
    id: 'remove_tag',
    main: false,
    name: 'Remove post tag',
  },
  {
    block: APIDocsUpdatePostBlock,
    id: 'update_post',
    main: false,
    name: 'Update post',
  },
  {
    block: APIDocsDeletePostBlock,
    id: 'delete_post',
    main: false,
    name: 'Delete post',
  },
  {
    block: APIDocsJiraLinkIssueBlock,
    id: 'jira_link_issue',
    main: false,
    name: 'Link Jira issue',
  },
  {
    block: APIDocsJiraUnlinkIssueBlock,
    id: 'jira_unlink_issue',
    main: false,
    name: 'Unlink Jira issue',
  },
  {
    block: APIDocsRoadmapsBlock,
    id: 'roadmaps',
    main: true,
    name: 'Roadmaps',
  },
  {
    block: APIDocsRoadmapObjectBlock,
    id: 'roadmap_object',
    main: false,
    name: 'Roadmaps',
  },
  {
    block: APIDocsStatusChangesBlock,
    id: 'status_changes',
    main: true,
    name: 'Status Changes',
  },
  {
    block: APIDocsStatusChangeObjectBlock,
    id: 'status_change_object',
    main: false,
    name: 'Status change object',
  },
  {
    block: APIDocsListStatusChangesBlock,
    id: 'list_status_changes',
    main: false,
    name: 'List status changes',
  },
  {
    block: APIDocsTagsBlock,
    id: 'tags',
    main: true,
    name: 'Tags',
  },
  {
    block: APIDocsTagObjectBlock,
    id: 'tag_object',
    main: false,
    name: 'Tag object',
  },
  {
    block: APIDocsRetrieveTagBlock,
    id: 'retrieve_tag',
    main: false,
    name: 'Retrieve tag',
  },
  {
    block: APIDocsListTagsBlock,
    id: 'list_tags',
    main: false,
    name: 'List tags',
  },
  {
    block: APIDocsCreateTagBlock,
    id: 'create_tag',
    main: false,
    name: 'Create tag',
  },
  {
    block: APIDocsUsersBlock,
    id: 'users',
    main: true,
    name: 'Users',
  },
  {
    block: APIDocsUserObjectBlock,
    id: 'user_object',
    main: false,
    name: 'User object',
  },
  {
    block: APIDocsListUsersBlock,
    id: 'list_users',
    main: false,
    name: 'List users',
  },
  {
    block: APIDocsRetrieveUserBlock,
    id: 'retrieve_user',
    main: false,
    name: 'Retrieve user',
  },
  {
    block: APIDocsCreateOrUpdateUserBlock,
    id: 'create_or_update_user',
    main: false,
    name: 'Create or update user',
  },
  {
    block: APIDocsDeleteUserBlock,
    id: 'delete_user',
    main: false,
    name: 'Delete user',
  },
  {
    block: APIDocsDeleteUserFromCompanyBlock,
    id: 'remove_user_from_company',
    main: false,
    name: 'Remove user from company',
  },
  {
    block: APIDocsVotesBlock,
    id: 'votes',
    main: true,
    name: 'Votes',
  },
  {
    block: APIDocsVoteObjectBlock,
    id: 'vote_object',
    main: false,
    name: 'Vote object',
  },
  {
    block: APIDocsRetrieveVoteBlock,
    id: 'retrieve_vote',
    main: false,
    name: 'Retrieve vote',
  },
  {
    block: APIDocsListVotesBlock,
    id: 'list_votes',
    main: false,
    name: 'List votes',
  },
  {
    block: APIDocsCreateVoteBlock,
    id: 'create_vote',
    main: false,
    name: 'Create vote',
  },
  {
    block: APIDocsDeleteVoteBlock,
    id: 'delete_vote',
    main: false,
    name: 'Delete vote',
  },
  {
    block: APIDocsWebhooksBlock,
    id: 'webhooks',
    main: true,
    name: 'Webhooks',
  },
  {
    block: APIDocsEventObjectBlock,
    id: 'event_object',
    main: false,
    name: 'Event object',
  },
  {
    block: APIDocsEventTypesBlock,
    id: 'event_types',
    main: false,
    name: 'Event types',
  },
  {
    block: APIDocsWebhookSignatureBlock,
    id: 'webhook_signature',
    main: false,
    name: 'Webhook signatures',
  },
  {
    block: APIDocsAIBlock,
    id: 'autopilot',
    main: true,
    name: 'Autopilot',
  },
  {
    block: APIDocsAIEnqueueFeedbackBlock,
    id: 'enqueue',
    main: false,
    name: 'Enqueue feedback',
  },
];

export default APIDocsSections;
